export const isValidNumber = (value: undefined | null | number | string): boolean => {
	if (value === null || value === undefined || value === '') {
		return false;
	}
	if (typeof value === 'number') {
		return !isNaN(value);
	}

	if (typeof value === 'string') {
		// Reject strings with spaces or non-numeric characters
		// Allows integers and decimals: '12', '12.3', '.5', '-0.2'
		return /^-?\d*(\.\d+)?$/.test(value.trim());
	}

	return false;
};
